// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paragraph-que textarea {\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}", "",{"version":3,"sources":["webpack://src/components/Questions/AdminView/AdminParagraph.component.style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB","sourcesContent":[".paragraph-que textarea {\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
